import { render, staticRenderFns } from "./AbonementBasic.vue?vue&type=template&id=400d747c&scoped=true&lang=pug&"
import script from "./AbonementBasic.vue?vue&type=script&lang=js&"
export * from "./AbonementBasic.vue?vue&type=script&lang=js&"
import style0 from "./AbonementBasic.vue?vue&type=style&index=0&id=400d747c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d747c",
  null
  
)

/* custom blocks */
import block0 from "./AbonementBasic.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports